const ROUTE_PERMISSION_RULES = [
  { pattern: /^\/$/, permission: ['dashboard.view', 'management_reports.view'] },
  { pattern: /^\/ops(?:\/|$)/, permission: 'operations.view' },
  { pattern: /^\/daily-plan(?:\/|$)/, permission: 'daily_plan.view' },
  { pattern: /^\/alerts(?:\/|$)/, permission: 'alerts.view' },
  { pattern: /^\/vet-smart-alerts(?:\/|$)/, permission: 'alerts.view' },
  { pattern: /^\/vet-command-center(?:\/|$)/, permission: 'vet_command_center.view' },

  { pattern: /^\/cows(?:\/|$)/, permission: 'cows.view' },
  { pattern: /^\/cows\/movement-history(?:\/|$)/, permission: 'cows.view' },
  { pattern: /^\/cows\/daily-herd-snapshots(?:\/|$)/, permission: 'cows.view' },
  { pattern: /^\/baharbands(?:\/|$)/, permission: 'baharbands.view' },
  { pattern: /^\/operational-people(?:\/|$)/, permission: 'operational_people.view' },
  { pattern: /^\/cow-documents(?:\/|$)/, permission: 'cow_documents.view' },
  { pattern: /^\/livestock-exit-events(?:\/|$)/, permission: 'livestock_exit_events.view' },
  { pattern: /^\/livestock-mortality-necropsy(?:\/|$)/, permission: 'livestock_exit_events.view' },
  { pattern: /^\/livestock-necropsy(?:\/|$)/, permission: 'livestock_exit_events.view' },
  { pattern: /^\/livestock-exit-causes(?:\/|$)/, permission: 'livestock_exit_events.view' },

  { pattern: /^\/calves(?:\/|$)/, permission: 'calves.view' },
  { pattern: /^\/calf-photo-sketches(?:\/|$)/, permission: 'calves.view' },
  { pattern: /^\/calf-image-search-history(?:\/|$)/, permission: 'calves.view' },
  { pattern: /^\/calf-events(?:\/|$)/, permission: 'calf_events.view' },
  { pattern: /^\/calf-daily-tasks(?:\/|$)/, permission: 'calf_daily_tasks.view' },
  { pattern: /^\/calf-growth-weighings(?:\/|$)/, permission: 'calf_growth_weighings.view' },
  { pattern: /^\/calf-treatment-sheets(?:\/|$)/, permission: ['calf_treatment_sheets.view', 'calf_treatment_sheets.create', 'calf_treatment_sheets.recover', 'calf_treatment_sheets.edit', 'calf_treatment_sheets.delete'] },
  { pattern: /^\/cow-treatment-sheets(?:\/|$)/, permission: 'cow_treatment_sheets.view' },
  { pattern: /^\/cow-treatment-history(?:\/|$)/, permission: ['cow_treatment_history.view', 'cow_treatment_sheets.view', 'health_reports.view'] },
  { pattern: /^\/cow-surgeries(?:\/|$)/, permission: ['cow_surgeries.view', 'cow_surgeries.create', 'cow_surgeries.edit'] },
  { pattern: /^\/cow-surgery-master-data(?:\/|$)/, permission: 'cow_surgeries.view' },
  { pattern: /^\/calf-treatment-protocols(?:\/|$)/, permission: 'calf_treatment_protocols.view' },
  { pattern: /^\/cow-treatment-protocols(?:\/|$)/, permission: 'cow_treatment_protocols.view' },
  { pattern: /^\/calf-treatment-ops(?:\/|$)/, permission: ['calf_treatment_sheets.view', 'calf_treatment_sheets.create', 'calf_treatment_sheets.recover', 'calf_treatment_sheets.edit'] },
  { pattern: /^\/calf-treatment-history(?:\/|$)/, permission: ['calf_reports.view', 'calf_treatment_sheets.view', 'calf_treatment_sheets.create', 'calf_treatment_sheets.edit', 'health_reports.view'] },
  { pattern: /^\/reports\/calf(?:\/|$)/, permission: 'calf_reports.view' },
  { pattern: /^\/calf-treatment-financial(?:\/|$)/, permission: 'calf_reports.view' },
  { pattern: /^\/calf-analytics(?:\/|$)/, permission: 'calf_reports.view' },
  { pattern: /^\/calf-growth-analytics(?:\/|$)/, permission: 'calf_reports.view' },
  { pattern: /^\/calf-clinical-scoring(?:\/|$)/, permission: 'calf_reports.view' },
  { pattern: /^\/calf-mortality-report(?:\/|$)/, permission: 'calf_reports.view' },
  { pattern: /^\/calf-milk-records(?:\/|$)/, permission: 'calf_milk_records.view' },
  { pattern: /^\/calf-milk-protocols(?:\/|$)/, permission: 'calf_milk_protocols.view' },
  { pattern: /^\/calf-milk-monthly-report(?:\/|$)/, permission: 'calf_reports.view' },

  { pattern: /^\/repro(?:\/|$)/, permission: 'reproduction.view' },
  { pattern: /^\/estrus(?:\/|$)/, permission: 'estrus.view' },
  { pattern: /^\/estrus\/new(?:\/|$)/, permission: 'estrus.create' },
  { pattern: /^\/repro\/vet-visit(?:\/|$)/, permission: 'vet_visit.view' },
  { pattern: /^\/repro\/visit-plans(?:\/|$)/, permission: 'vet_visit.view' },
  { pattern: /^\/repro\/services(?:\/|$)/, permission: 'services.view' },
  { pattern: /^\/repro\/pregnancy-checks(?:\/|$)/, permission: 'pregnancy_checks.view' },
  { pattern: /^\/repro\/abortions(?:\/|$)/, permission: 'abortions.view' },
  { pattern: /^\/repro\/dryoffs(?:\/|$)/, permission: 'dryoffs.view' },
  { pattern: /^\/repro\/calvings(?:\/|$)/, permission: 'calvings.view' },
  { pattern: /^\/repro\/reports(?:\/|$)/, permission: 'repro_reports.view' },
  { pattern: /^\/repro\/timeline(?:\/|$)/, permission: 'repro_reports.view' },
  { pattern: /^\/repro\/service-days-range(?:\/|$)/, permission: 'repro_reports.view' },
  { pattern: /^\/repro\/fertility-neglected-milking(?:\/|$)/, permission: 'repro_reports.view' },
  { pattern: /^\/repro\/calving-information(?:\/|$)/, permission: 'repro_reports.view' },
  { pattern: /^\/repro\/calving-forecast(?:\/|$)/, permission: 'repro_reports.view' },
  { pattern: /^\/repro\/revisits(?:\/|$)/, permission: 'repro_reports.view' },
  { pattern: /^\/repro\/semen-inventory(?:\/|$)/, permission: 'semen_inventory.view' },

  { pattern: /^\/health(?:\/|$)/, permission: 'health.view' },
  { pattern: /^\/health\/workbench(?:\/|$)/, permission: 'health_workbench.view' },
  { pattern: /^\/health\/hospital(?:\/|$)/, permission: 'hospital_admissions.view' },
  { pattern: /^\/fresh-cow-monitoring(?:\/|$)/, permission: 'fresh_cow_checks.view' },
  { pattern: /^\/lab-tests(?:\/|$)/, permission: 'lab_tests.view' },
  { pattern: /^\/treatments(?:\/|$)/, permission: 'treatments.view' },
  { pattern: /^\/treatments\/new(?:\/|$)/, permission: 'treatments.create' },
  { pattern: /^\/treatments\/[^/]+\/edit(?:\/|$)/, permission: 'treatments.edit' },
  { pattern: /^\/drugs(?:\/|$)/, permission: 'drugs.view' },
  { pattern: /^\/drug-lots(?:\/|$)/, permission: 'drugs.view' },
  { pattern: /^\/medication-withdrawal-report(?:\/|$)/, permission: 'health_reports.view' },
  { pattern: /^\/treatment-outcome-analytics(?:\/|$)/, permission: 'health_reports.view' },
  { pattern: /^\/medication-batches(?:\/|$)/, permission: 'treatments.view' },
  { pattern: /^\/disease-master-data(?:\/|$)/, permission: 'disease_master_data.view' },
  { pattern: /^\/preventive-care(?:\/|$)/, permission: 'preventive_care.view' },
  { pattern: /^\/udder-health(?:\/|$)/, permission: 'udder_health.view' },
  { pattern: /^\/lameness-events(?:\/|$)/, permission: 'lameness_events.view' },
  { pattern: /^\/vaccination-protocols(?:\/|$)/, permission: 'vaccination_protocols.view' },
  { pattern: /^\/repro\/vet-health-report(?:\/|$)/, permission: 'health_reports.view' },
  { pattern: /^\/repro\/udder-lameness-report(?:\/|$)/, permission: 'health_reports.view' },
  { pattern: /^\/repro\/udder-lameness-operations(?:\/|$)/, permission: 'health_reports.view' },
  { pattern: /^\/repro\/vet-phase2-summary(?:\/|$)/, permission: 'health_reports.view' },

  { pattern: /^\/milk-records(?:\/|$)/, permission: 'milk_records.view' },
  { pattern: /^\/milk-quality-report(?:\/|$)/, permission: 'milk_reports.view' },
  { pattern: /^\/milk-advanced-analytics(?:\/|$)/, permission: 'milk_reports.view' },
  { pattern: /^\/milk-health-impact(?:\/|$)/, permission: 'milk_reports.view' },
  { pattern: /^\/fertility-health-impact(?:\/|$)/, permission: 'repro_reports.view' },
  { pattern: /^\/phase4\/milk-sales(?:\/|$)/, permission: 'milk_sales.view' },

  { pattern: /^\/feed-dashboard(?:\/|$)/, permission: 'inventory_reports.view' },
  { pattern: /^\/feed-start-guide(?:\/|$)/, permission: ['feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'inventory_reports.view'] },
  { pattern: /^\/feed-excel-import(?:\/|$)/, permission: ['feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'procurement.view'] },
  { pattern: /^\/feed-nutrition-inventory(?:\/|$)/, permission: ['feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'inventory_reports.view'] },
  { pattern: /^\/feed-baharband-rations(?:\/|$)/, permission: ['feed_operations.view', 'baharbands.view'] },
  { pattern: /^\/feed-daily-fast-entry(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-management-reports(?:\/|$)/, permission: 'inventory_reports.view' },
  { pattern: /^\/feed-performance-analytics(?:\/|$)/, permission: 'inventory_reports.view' },
  { pattern: /^\/feed-alert-dashboard(?:\/|$)/, permission: 'inventory_reports.view' },
  { pattern: /^\/calf-feed-age-intake(?:\/|$)/, permission: ['calf_reports.view', 'feed_operations.view'] },
  { pattern: /^\/feed-iofc(?:\/|$)/, permission: 'inventory_reports.view' },
  { pattern: /^\/feed-inventory(?:\/|$)/, permission: 'feed_inventory.view' },
  { pattern: /^\/feed-items(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/feed-categories(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/feed-waste-causes(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/feed-loss-causes(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/feed-residual-causes(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/feed-overhead-types(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/feeding-groups(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/feed-rations(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-purchases(?:\/|$)/, permission: 'procurement.view' },
  { pattern: /^\/feed-planned-consumptions(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-scale-tickets(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-scale-distributions(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-consumptions(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-wastes(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-losses(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-residuals(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-overheads(?:\/|$)/, permission: 'feed_operations.view' },
  { pattern: /^\/feed-operational-cost(?:\/|$)/, permission: 'feed_operations.view' },

  { pattern: /^\/suppliers(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/counterparties(?:\/|$)/, permission: ['counterparties.view', 'milk_sales.view', 'financial_data.view'] },
  { pattern: /^\/supply-inventory(?:\/|$)/, permission: 'supply_inventory.view' },
  { pattern: /^\/supply-purchases(?:\/|$)/, permission: 'procurement.view' },
  { pattern: /^\/supply-consumptions(?:\/|$)/, permission: 'supply_inventory.view' },
  { pattern: /^\/purchase-requests(?:\/|$)/, permission: 'procurement.view' },
  { pattern: /^\/purchase-orders(?:\/|$)/, permission: 'procurement.view' },
  { pattern: /^\/storage-locations(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/semen-storage-positions(?:\/|$)/, permission: 'feed_master_data.view' },
  { pattern: /^\/goods-receipts(?:\/|$)/, permission: 'inventory_documents.view' },
  { pattern: /^\/opening-inventories(?:\/|$)/, permission: 'inventory_documents.view' },
  { pattern: /^\/stock-counts(?:\/|$)/, permission: 'inventory_documents.view' },
  { pattern: /^\/inventory-on-hand(?:\/|$)/, permission: 'inventory_reports.view' },
  { pattern: /^\/inventory-alerts(?:\/|$)/, permission: 'inventory_reports.view' },

  { pattern: /^\/reports(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/command-center(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/operational(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/analytical(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/herd-dashboard(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/management-executive(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/smart-alert-center(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/management-settings(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/custom-builder(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/performance-center(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/herd-snapshot-history(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/management-economic-decision(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/reports\/decision-analytics(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/reports\/predictive-risk(?:\/|$)/, permission: 'reports.view' },
  { pattern: /^\/phase3\/operational-summary(?:\/|$)/, permission: 'inventory_reports.view' },
  { pattern: /^\/phase4\/executive-dashboard(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/phase4\/management-cost-analysis(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/phase4\/profitability-analysis(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/finance\/engine(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/finance\/culling-replacement(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/herd\/capacity-flow(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/alerts\/corrective-center(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/management\/scenarios(?:\/|$)/, permission: 'management_reports.view' },
  { pattern: /^\/economic(?:\/|$)/, permission: 'financial_data.view' },
  { pattern: /^\/phase4\/cost-centers(?:\/|$)/, permission: 'financial_data.view' },
  { pattern: /^\/phase4\/operating-expenses(?:\/|$)/, permission: 'financial_data.view' },
  { pattern: /^\/phase4\/revenue-entries(?:\/|$)/, permission: 'financial_data.view' },
  { pattern: /^\/phase4\/livestock-sales(?:\/|$)/, permission: 'financial_data.view' },
  { pattern: /^\/phase4\/allocation-rules(?:\/|$)/, permission: 'financial_data.view' },

  { pattern: /^\/audit-logs(?:\/|$)/, permission: 'audit_logs.view' },
  { pattern: /^\/user-daily-activity(?:\/|$)/, permission: 'audit_logs.view' },
  { pattern: /^\/import-jobs(?:\/|$)/, permission: ['audit_logs.view', 'services.view', 'pregnancy_checks.view', 'dryoffs.view', 'calvings.view', 'semen_inventory.view', 'feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'inventory_documents.view'] },
  { pattern: /^\/registered-data-edit(?:\/|$)/, permission: 'registered_data_edit.view' },
  { pattern: /^\/settings(?:\/|$)/, permission: 'settings.view' },
  { pattern: /^\/settings\/backups(?:\/|$)/, permission: 'system_backups.view' },
  { pattern: /^\/settings\/power-user(?:\/|$)/, permission: 'power_user.view' },
  { pattern: /^\/protocols(?:\/|$)/, permission: 'protocols.view' },
  { pattern: /^\/protocols\/new(?:\/|$)/, permission: 'protocols.create' },
  { pattern: /^\/protocols\/[^/]+\/edit(?:\/|$)/, permission: 'protocols.edit' },
  { pattern: /^\/repro\/hormone-therapy(?:\/|$)/, permission: 'treatments.view' },
  { pattern: /^\/repro\/hormone-therapy\/new(?:\/|$)/, permission: 'treatments.create' },
  { pattern: /^\/repro\/hormone-therapy\/[^/]+(?:\/|$)/, permission: 'treatments.view' },
  { pattern: /^\/repro\/hormone-therapy\/[^/]+\/edit(?:\/|$)/, permission: 'treatments.edit' },
  { pattern: /^\/repro\/hormone-therapy-protocols(?:\/|$)/, permission: 'protocols.view' },
  { pattern: /^\/repro\/hormone-therapy-protocols\/new(?:\/|$)/, permission: 'protocols.create' },
  { pattern: /^\/repro\/hormone-therapy-protocols\/[^/]+\/edit(?:\/|$)/, permission: 'protocols.edit' },
];

export function getPermissionForPath(pathname = '') {
  const matches = ROUTE_PERMISSION_RULES.filter((rule) => rule.pattern.test(pathname || ''));
  return matches.length ? matches[matches.length - 1].permission : null;
}

export function getPermissionForHref(href = '') {
  if (!href) return null;
  const [pathname] = String(href).split('?');
  return getPermissionForPath(pathname);
}

export { ROUTE_PERMISSION_RULES };
